import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=4b5bfa4e&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
import style0 from "./Home.vue?vue&type=style&index=0&id=4b5bfa4e&prod&scoped=true&lang=scss"
import style1 from "./Home.vue?vue&type=style&index=1&id=4b5bfa4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5bfa4e",
  null
  
)

export default component.exports